/**
 * @generated SignedSource<<d986ca8f0840593b87371d1db847fdf0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NumberCell$data = {
  readonly isStoryPointField: boolean | null | undefined;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"NumberCell_NumberInlineEditCell" | "StoryPointEstimateCell">;
  readonly " $fragmentType": "NumberCell";
};
export type NumberCell$key = {
  readonly " $data"?: NumberCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"NumberCell">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isInlineEditingEnabled",
    "variableName": "isInlineEditingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "NumberCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "NumberCell_NumberInlineEditCell"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "StoryPointEstimateCell"
    }
  ],
  "type": "JiraNumberField"
};
})();

(node as any).hash = "c443aa487352d4791d3b2181e5622bfa";

export default node;
